import React, { Component } from 'react'
import _ from 'lodash'

import { updateModuleData } from 'helpers/specHelpers'
import ListSpec from 'containers/Project/ListSpec/index'

class PanelSpec extends Component {
  render() {
    const {
      moduleData,
      isModifiedPage,
      curFilter,
      ModuleHeader,
    } = this.props

    const panelData = moduleData['panel']
    if(!panelData) return null

    const newModuleData = updateModuleData(_.cloneDeep(panelData),
      (dataArr) => dataArr.map(data => {
        if (data.width && data.height) {
          return {
            resolution:  `${data.width}x${data.height}`,
            ...data,
          }
        }
      }).filter(data => data)) // filter out invalid values

    return (
      <ListSpec
        moduleName='panel'
        moduleData={ newModuleData && ((newModuleData.initValues && newModuleData.initValues.length > 0) ||
                     (newModuleData.modifiedValues && newModuleData.modifiedValues.length > 0)) ?
                      newModuleData : null }
        isModifiedPage={isModifiedPage}
        curFilter={curFilter}
        ModuleHeader={ModuleHeader}
      />
    )
  }
}

export default PanelSpec
